import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Divider, TextField, Typography, useMediaQuery } from '@mui/material';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import ArticleEditorToolbar from './ArticleEditorToolbar';

export default function ArticleEditor({ article/*, categories*/, createMode, onSave, onCancel, saving }) {
  const [title, setTitle] = useState(article.title);
  const [description, setDescription] = useState(article.description);
  const [tags, setTags] = useState(article.tags.join(', '));
  //const [category, setCategory] = useState(article.categoryPath[0] || '');
  const isMobile = useMediaQuery('(max-width:600px)');

  const editor = useEditor({
    extensions: [StarterKit],
    content: article.content,
    shouldRerenderOnTransaction: true, //Performance optimization: Only re-renders when it’s necessary
  });

  const handleSave = () => {
    onSave?.({
      ...article,
      id: article.articleId,
      title: title.trim(),
      description: description?.trim(),
      tags: tags.split(',').map(t => t.trim()).filter(Boolean),
      content: (editor && !editor.isEmpty) && editor.getHTML(),
    });
  };

  return (
    <Box sx={{ maxWidth: '800px', mx: 'auto', py: 4, px: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {createMode ?
          <FormattedMessage id="helpCenter.article.create" /> :
          <FormattedMessage id="helpCenter.article.edit" />
        }
      </Typography>

      <TextField
        label="Rubrik"
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Ingress"
        fullWidth
        value={description || ""}
        onChange={(e) => setDescription(e.target.value)}
        sx={{ mb: 2 }}
      />

      {/*<Typography variant="subtitle1" sx={{ mb: 1 }}>Kategori</Typography>
      <Select
        fullWidth
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="">Ingen</MenuItem>
        {categories.map(cat => (
          <MenuItem key={cat} value={cat}>{cat}</MenuItem>
        ))}
      </Select>*/}

      <Typography variant="subtitle1" sx={{ mb: 1 }}>Innehåll</Typography>

      {/* Toolbar */}
      <ArticleEditorToolbar editor={editor} isMobile={isMobile} />

      <Divider sx={{ mb: 1 }} />

      {/* Editor content */}
      <Box sx={{
        border: '1px solid #ccc',
        borderRadius: 1,
        mb: 2,
        minHeight: '150px',
        '& .ProseMirror': {
          cursor: 'text',
          minHeight: '150px',
          outline: 'none',
          px: 2,
          py: 0,
        },
      }}>
        <EditorContent editor={editor} />
      </Box>

      <TextField
        label="Taggar (komma-separerat)"
        fullWidth
        value={tags}
        onChange={(e) => setTags(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', gap: 2, flexDirection: isMobile ? 'column' : 'row' }}>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          <FormattedMessage id="btn.save" />
        </Button>
        <Button variant="outlined" onClick={onCancel} disabled={saving}>
          <FormattedMessage id="btn.cancel" />
        </Button>
      </Box>
    </Box>
  );
}
